import React from 'react';
import cx from 'classnames';

import Text from '../Text';

import baseStyles from '../BaseInput/BaseInput.module.scss';
import styles from './ToggleSwitch.module.scss';

export interface Props {
  children: React.ReactNode;
  className?: Parameters<typeof cx>[0];
  disabled?: boolean;
  id: string;
  name?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  right?: boolean;
  value: boolean;
  trueText?: string;
  falseText?: string;
}

export const ToggleSwitch: React.FC<Props> = ({
  children,
  className,
  disabled,
  id,
  name,
  onChange,
  right,
  value,
  trueText,
  falseText,
}) => {
  return (
    <div
      className={cx(
        baseStyles.container,
        styles.container,
        disabled && styles.disabled,
        right && styles.right,
        className,
      )}
    >
      <input
        checked={value}
        className={cx(styles.input)}
        disabled={disabled}
        id={id}
        name={name}
        onChange={onChange}
        type='checkbox'
      />
      <label className={cx(styles.label, value && styles.checked)} htmlFor={id}>
        <span role='presentation' className={styles.toggleContainer}>
          <span className={styles.toggle}>
            <span className={styles.toggleKnob} />
          </span>
          <span className={styles.textWrapper}>
            <Text as='span' className={cx(!value && styles.hide)}>
              {trueText || 'ON'}
            </Text>
            <Text
              as='span'
              className={cx(styles.falseText, value && styles.hide)}
            >
              {falseText || 'OFF'}
            </Text>
          </span>
        </span>
        <Text as='span'>{children}</Text>
      </label>
    </div>
  );
};

ToggleSwitch.displayName = 'ToggleSwitch';
export default ToggleSwitch;
export { styles };
